module.exports = __webpack_public_path__ + "static/nz_digital_wallet-garmin-pay-watch-e3a50d6b11f38301d17dac0f5f01cd51.png";